<template>
  <NuxtLink :to="link" class="editorial-nav-link" @click="useTrackEvent(title)">
    {{ title }}
  </NuxtLink>
</template>
<script setup lang="ts">
defineProps<{ link: string; title: string }>()
</script>
